/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Logs_Column_Risk_LevelInputs */



/**
* | output |
* | --- |
* | "Risk Level" |
*
* @param {Audit_Logs_Column_Risk_LevelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_logs_column_risk_level = /** @type {((inputs?: Audit_Logs_Column_Risk_LevelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Logs_Column_Risk_LevelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Risikostufe")
	return /** @type {LocalizedString} */ ("Risk Level")
});